// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"bdf6e146","84":"d7008b29","415":"194a048c","482":"c819a6b1","689":"0e1b9673","993":"3eb26be4"}[chunkId] + ".chunk.js";
};